import { FeatureSource } from '@/types/api/product';
import { type CookieStore } from '@/utilities/cookieStore';
import { createFeatures, type Features } from '@/utilities/features';

/**
 * Parses the `stsp` cookie's comma-separated value into a list of experiment IDs.
 */
export const stspIdsFromCookie = (cookies: CookieStore): string[] =>
  (cookies.get('stsp') ?? '')
    .split(',')
    .map(id => id.trim())
    .filter(id => id.length > 0);

/**
 * Represents active SiteSpect experiments as Features, ready to merge into another Features instance.
 */
export const stspFeaturesFromCookie = (cookies: CookieStore): Features => {
  const stspIds = stspIdsFromCookie(cookies);
  return createFeatures(
    stspIds.map(name => ({ name, source: FeatureSource.FilterExperiment })),
    stspIds,
  );
};
